import React, { useState } from "react"; // eslint-disable-line react/react-in-jsx-scope
import { Button, Modal, Form, Message } from "semantic-ui-react";
import { DateInput } from "semantic-ui-calendar-react";
import { DateFormat, InvoiceStatuses, PaymentMethods } from "utilities/dist/invoice/constants";
import { format } from "date-fns";
import { handleFintechCsvExport } from "../../invoice/helpers";
import { makePrivateApiCall } from "utilities/dist/api";

export const FintechExport = ({ open, onClose, company }) => {
    const MomentDateFormat = "yyyy-MM-dd";
    const today = new Date();
    const [date, setDate] = useState(today);
    const [exportError, setExportError] = useState();

    const searchInvoiceByDate = async date => {
        const params = {
            filterModel: {
                invoiced_date: {
                    filterType: "date",
                    type: "equals",
                    dateFrom: date,
                    dateTo: null,
                },
            },
        };

        const { data } = await makePrivateApiCall({
            url: "/invoice/grid",
            method: "get",
            params,
        });

        return data;
    };

    const handleExport = async () => {
        const { rows } = await searchInvoiceByDate(format(date, MomentDateFormat));
        const invoices = rows
            .filter(inv =>
                inv.statusInfo.find(info => info.new_status === InvoiceStatuses.INVOICED)
            )
            .map(inv => ({
                ...inv,
                ft_amount: inv.payments
                    .map(pay => (pay.payment_method === PaymentMethods.FINTECH ? pay.amount : 0))
                    .reduce((a, v) => a + v, 0),
            }))
            .filter(inv => inv.total.toFixed(2) === inv.ft_amount.toFixed(2))
            .filter(inv => !!inv.customer?.fintech_option);

        if (invoices.length > 0) {
            handleFintechCsvExport(
                invoices,
                company,
                `export_${format(
                    date,
                    MomentDateFormat
                )}_${PaymentMethods.FINTECH.toLowerCase()}.csv`
            );
            setExportError(null);
            onClose();
        } else {
            setExportError("No eligible Fintech invoices found for this date!");
        }
    };

    const handleCancel = () => {
        setExportError(null);
        onClose();
    };

    const handleDateChange = (event, { name, value }) => {
        if (name === "date") {
            setDate(new Date(value));
            setExportError(null);
        }
    };

    return (
        <Modal
            size="tiny"
            open={open}
            onMount={() => setDate(today)}
            closeOnEscape={true}
            closeOnDimmerClick={false}
            onClose={onClose}
            data-cy="fintech_export_data_modal"
        >
            <Modal.Header data-cy="fintech_export_data_header">Export Fintech data</Modal.Header>

            <Modal.Content>
                {exportError && (
                    <Message
                        data-cy="fintech_export_message"
                        positive
                        onDismiss={() => setExportError(null)}
                        content={exportError}
                    />
                )}
                <Form>
                    <Form.Field>
                        <label>Invoiced date</label>
                        <DateInput
                            data-cy="fintech_export_date_input"
                            name="date"
                            placeholder="Date"
                            value={format(date, DateFormat)}
                            maxDate={today}
                            dateFormat={DateFormat.toUpperCase()}
                            iconPosition="left"
                            animation={null}
                            closable
                            onChange={handleDateChange}
                        />
                    </Form.Field>
                </Form>
            </Modal.Content>

            <Modal.Actions>
                <Button
                    data-cy="fintech_export_generate_button"
                    positive
                    content="Generate Export"
                    onClick={handleExport}
                    disabled={false}
                />
                <Button
                    data-cy="fintech_export_cancel_button"
                    negative
                    content="Cancel"
                    onClick={handleCancel}
                />
            </Modal.Actions>
        </Modal>
    );
};
